import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollHandler = () => {
  const location = useLocation();

  useEffect(() => {
    // Espera a que React renderice el contenido
    setTimeout(() => {
      // Obtener el hash de la URL (ej: #ganancias)
      const hash = location.hash;

      if (hash) {
        // Remover el # para obtener el ID
        const elementId = hash.replace("#", "");
        const element = document.getElementById(elementId);

        if (element) {
          // Scroll suave con offset para el header fijo
          const headerHeight = 80; // Altura de tu header
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });

          // También actualizar la URL sin recargar
          window.history.replaceState(null, null, hash);
        }
      } else {
        // Si no hay hash, scroll al inicio
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }, 100); // Pequeño delay para asegurar renderizado
  }, [location]);

  return null; // No renderiza nada
};

export default ScrollHandler;
